import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import RadioSwatch from './RadioSwatch';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * If provided, RadioSwatch components will be rendered based on this data
   * @typeName radioSwatchData
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    color: PropTypes.string,
    outOfStock: PropTypes["boolean"],
    disabled: PropTypes["boolean"]
  })),

  /**
   * @deprecated data
   */
  children: PropTypes.node,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   * If provided, the RadioSwatch component with a corresponding value will be selected when the RadioSwatchGroup is rendered.
   */
  defaultValue: PropTypes.string,

  /**
   * If provided, the name of RadioSwatch component is rendered.
   */
  name: PropTypes.string,

  /**
   * Optional function that is called when RadioSwatch component is selected. If provided, it will be called with a DOM form event object from selected Radio.
   */
  onChange: PropTypes.func,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * @ignore
   */
  disabledState: PropTypes.bool
};
var defaultProps = {
  className: null,
  defaultValue: null,
  name: null,
  onChange: function onChange() {},
  disabledState: true
};
var RadioSwatchGroupWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioSwatchGroupWrapper",
  componentId: "z2qgs1-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var InputWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "InputWrapper",
  componentId: "z2qgs1-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), calculateRem(16));

var RadioSwatchGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioSwatchGroup, _React$Component);

  var _super = _createSuper(RadioSwatchGroup);

  function RadioSwatchGroup(props) {
    var _this;

    _classCallCheck(this, RadioSwatchGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleColorSelect", function (e) {
      _this.props.onChange(e);

      _this.setState({
        selectedColor: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_dontSelect", function (e) {
      if (e.nativeEvent.clientX === 0 && e.nativeEvent.clientY === 0 && e.key !== 'Enter') {
        return true;
      } else {
        return false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleColorSelectArray", function (e, index, data) {
      var nextSwatch = index < data.length && document.getElementById("swatchId".concat(index + 1)).getAttribute('value');
      var prevSwatch = index > 1 && document.getElementById("swatchId".concat(index - 1)).getAttribute('value');
      var firstSwatch = document.getElementById("swatchId".concat(1)).getAttribute('value');
      var lastSwatch = document.getElementById("swatchId".concat(data.length)).getAttribute('value'); //This is to help us focus on any disabled options and continue moving through the options

      if (_this._dontSelect(e)) return;
      _this.props.onChange && _this.props.onChange(e);

      _this.setState({
        selectedColor: e.currentTarget.getAttribute('value')
      }); // onKeyDown navigation


      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        if (nextSwatch) {
          _this.setState({
            selectedColor: nextSwatch
          });
        } else {
          _this.setState({
            selectedColor: firstSwatch
          });
        }
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        if (prevSwatch) {
          _this.setState({
            selectedColor: prevSwatch
          });
        } else {
          _this.setState({
            selectedColor: lastSwatch
          });
        }
      }
    });

    _this.state = {
      selectedColor: _this.props.defaultValue
    };
    return _this;
  }

  _createClass(RadioSwatchGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps && this.props.defaultValue !== prevProps.defaultValue) {
        this.setState({
          selectedColor: this.props.defaultValue
        });
      }
    }
  }, {
    key: "renderColorSelects",
    value: // Maintain backwards compatibility
    function renderColorSelects() {
      var _this2 = this;

      var children = this.props.children;
      return React.Children.map(children, function (child, index) {
        var isLastChild = children.length - 1 === index;
        return /*#__PURE__*/React.cloneElement(child, {
          key: index + 1,
          selected: _this2.state.selectedColor === child.props.value,
          checked: _this2.state.selectedColor === child.props.value,
          onChange: _this2.handleColorSelect,
          lastChild: isLastChild,
          typescale: _this2.props.typescale,
          typographyConfig: _this2.props.typographyConfig,
          bodyConfig: _this2.props.bodyConfig
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          data = _this$props.data,
          bodyConfig = _this$props.bodyConfig,
          typographyConfig = _this$props.typographyConfig,
          value = _this$props.value,
          focusSize = _this$props.focusSize,
          focusState = _this$props.focusState,
          labelMargin = _this$props.labelMargin,
          labelMaxWidth = _this$props.labelMaxWidth,
          labelMinWidth = _this$props.labelMinWidth,
          swatchMargin = _this$props.swatchMargin,
          size = _this$props.size,
          selectedStateDoubleBorder = _this$props.selectedStateDoubleBorder,
          disabledState = _this$props.disabledState,
          typescale = _this$props.typescale,
          id = _this$props.id;
      return /*#__PURE__*/React.createElement(Fragment, null, children && /*#__PURE__*/React.createElement(InputWrapper, {
        id: id,
        className: className,
        role: "radiogroup"
      }, this.renderColorSelects()), data && /*#__PURE__*/React.createElement(RadioSwatchGroupWrapper, _extends({}, this.props, {
        id: id,
        "data-testid": "test-color-input"
      }), data.map(function (child, index) {
        var inputId = child.inputId;
        return /*#__PURE__*/React.createElement(RadioSwatch, _extends({}, child, {
          id: "swatchId".concat(index + 1),
          inputId: inputId,
          key: ++index,
          disabled: child.disabled,
          disabledState: disabledState,
          outOfStock: child.outOfStock,
          color: child.color,
          label: child.label,
          value: child.value,
          checked: _this3.state.selectedColor === child.value,
          selected: _this3.state.selectedColor === child.value,
          onChange: child.disabled && disabledState ? function () {} : function (e) {
            return _this3.handleColorSelectArray(e, index, data);
          },
          onKeyDown: function onKeyDown(e) {
            return _this3.handleColorSelectArray(e, index, data);
          },
          bodyConfig: child.bodyConfig || bodyConfig,
          typographyConfig: child.typographyConfig || typographyConfig,
          focusSize: focusSize,
          focusState: focusState,
          labelMargin: labelMargin,
          labelMaxWidth: labelMaxWidth,
          labelMinWidth: labelMinWidth,
          swatchMargin: swatchMargin,
          size: size,
          typescale: child.typescale || typescale,
          selectedStateDoubleBorder: selectedStateDoubleBorder,
          numberOfSwatches: data.length
        }));
      })));
    }
  }]);

  return RadioSwatchGroup;
}(React.Component);

RadioSwatchGroup.propTypes = propTypes;
RadioSwatchGroup.defaultProps = defaultProps;
export default withVDSManager(RadioSwatchGroup);